import React from 'react';
import ModuleContainer from '../../components/ModuleContainer';
import MemberHeader from '../../components/MemberHeader';
import Logo from '../../../includes/img/logo.png';
import { SUCCESS_RESPONSE, RESPONSE_BODY } from '../../../utils/messages';

const DonationResponse = () => {
    return (
        <div>
            <MemberHeader />
            <ModuleContainer>
                <center>
                    <img alt="shsaaa-logo" src={Logo} style={{width: 180, height: 180}}/>
                    <h2>{SUCCESS_RESPONSE}</h2>
                    <h5>{RESPONSE_BODY}</h5>
                </center>
            </ModuleContainer>
        </div>
    );
};

export default DonationResponse;